export const GroupUnsimplifier = {
  MAPPING: {
    i: 'id',
    t: 'title',
    d: 'description',
    dh: 'description_html',
    ciu: 'cover_image_url',
    cit: 'cover_image_thumbnail_url',
    cim: 'cover_image_medium_url',
    ia: 'is_archived',
    mc: 'member_count',
    iv: 'is_verified',
    im: 'is_moderated',
    ca: 'created_at',
    ip: 'is_private',
    ivs: 'is_visible',
    sl: 'slug',
    u: 'url',
    gc: 'group_category',
    pw: 'password',
    hp: 'has_password',
    ipd: 'is_paused',
    tc: 'theme_color',
    r: 'rules',
    iav: 'is_admins_visible',
    imv: 'is_members_visible',
    ilv: 'is_links_visible',
    aq: 'allow_quotes'
  },

  unsimplifyKey(simplifiedKey) {
    return this.MAPPING[simplifiedKey] || simplifiedKey;
  },

  unsimplify(data) {
    if (Array.isArray(data)) {
      return data.map(this.unsimplifyObject.bind(this));
    } else {
      return this.unsimplifyObject(data);
    }
  },

  unsimplifyObject(obj) {
    const newObj = {};
    for (const key in obj) {
      const unsimplifiedKey = this.unsimplifyKey(key);
      newObj[unsimplifiedKey] = obj[key];
    }
    return newObj;
  }
};